var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inputContainer"},_vm._l((Number(_vm.amount)),function(n){return _c('input',{key:n,staticClass:"input",attrs:{"id":n,"type":"text","placeholder":_vm.placeholder},on:{"input":function($event){return _vm.handleInput($event, n - 1)},"keyup":function($event){return _vm.onkey($event)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }